export default function Hero() {
  const handleScroll = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/3e48326f542c69a172179c4a4c069117.jpg"
          alt="Premium indoor vehicle storage facility with cinematic lighting"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/80"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 lg:px-12 max-w-5xl mx-auto">
        <p className="font-sans text-gold text-xs tracking-[0.35em] uppercase font-semibold mb-6 animate-fade-in">
          Premium Vehicle Protection &amp; Private Storage
        </p>
        <h1 className="font-serif text-white text-5xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6 animate-fade-up">
          Secure Indoor Storage
          <br />
          <em className="text-gold not-italic">Built for Collectors.</em>
        </h1>
        <p className="font-sans text-[#C8C8C8] text-lg md:text-xl leading-relaxed mb-10 max-w-2xl mx-auto animate-fade-up">
          Climate-controlled, fully-alarmed indoor vehicle storage for cars, motorcycles, RVs and specialty vehicles — serving the Bay Area since 1961.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-14 animate-fade-up">
          <button
            onClick={() => handleScroll("#contact")}
            className="font-sans text-sm font-semibold bg-gold text-charcoal px-8 py-4 rounded tracking-wide hover:bg-gold-light transition-all duration-200 cursor-pointer whitespace-nowrap shadow-lg shadow-gold/20"
          >
            Reserve Storage Space
          </button>
          <a
            href="tel:4154914140"
            className="font-sans text-sm font-medium border border-white/40 text-white px-8 py-4 rounded tracking-wide hover:border-gold hover:text-gold transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line text-sm"></i>
            </div>
            Speak With a Specialist
          </a>
        </div>

        {/* Stats */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-16">
          {[
            { value: "65+", label: "Years in Business" },
            { value: "2", label: "Secure Locations" },
            { value: "100%", label: "Indoor Protection" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <span className="font-serif text-gold text-3xl font-bold block">{stat.value}</span>
              <span className="font-sans text-[#9A9A9A] text-xs tracking-wider uppercase mt-1 block">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-5 h-8 border-2 border-white/30 rounded-full flex items-start justify-center pt-1.5">
          <div className="w-1 h-2 bg-gold rounded-full"></div>
        </div>
      </div>
    </section>
  );
}
